import React from 'react';
import { Box, Title, Text, Grid, Card, Group } from '@mantine/core';
import { Apple, Puzzle, Compass, FlaskConical } from 'lucide-react';
interface HomeProps {
  onNavigate: (item: string) => void;
}
export function Home({
  onNavigate
}: HomeProps) {
  const features = [{
    title: 'Vector',
    description: 'Explore 7 dimensions of health and get a 12-element radar report of your current nutrition approach.',
    icon: <Apple size={24} className="text-emerald-600" data-id="element-194" />,
    value: 'vector'
  }, {
    title: 'Build',
    description: 'Pick your three top priority health outcomes, and get the most compatible nutrition plans that fit them.',
    icon: <Puzzle size={24} className="text-emerald-600" data-id="element-195" />,
    value: 'build'
  }, {
    title: 'Explore',
    description: 'Understand all the different ways you can approach your nutrition in an easy-to-read format.',
    icon: <Compass size={24} className="text-emerald-600" data-id="element-196" />,
    value: 'explore'
  }];
  return <Box className="p-8 bg-white rounded-lg shadow-sm" data-id="element-197">
      <Title order={2} className="mb-4 text-slate-800" data-id="element-198">
        Welcome to Nutrivector
      </Title>
      <Text className="text-slate-600 mb-6" data-id="element-199">
        Your personalized nutrition protocol builder. Navigate through our tools
        to create and understand custom nutrition plans tailored to your goals,
        preferences, and lifestyle.
      </Text>
      <Grid gutter="lg" data-id="element-200">
        {features.map(feature => <Grid.Col key={feature.value} span={{
        base: 12,
        md: 6,
        lg: 4
      }} data-id="element-201">
            <Card shadow="sm" p="lg" radius="md" className="a-full, cursor-pointer, transition-all, hover:shadow-md, hover:translate-y-[-2px]" onClick={() => onNavigate(feature.value)} data-id="element-202">
              <Group className="mb-3" data-id="element-203">
                {feature.icon}
                <Title order={3} className="text-xl font-semibold text-slate-800" data-id="element-204">
                  {feature.title}
                </Title>
              </Group>
              <Text className="text-slate-600" data-id="element-205">{feature.description}</Text>
            </Card>
          </Grid.Col>)}
      </Grid>
    </Box>;
}